import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { LockIcon, VictoryIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

export const PetitionStatusHeader: React.FC<EmptyProps> = () => {
	const {
		data: {
			petition: { status, isVerifiedVictory },
		},
	} = usePetitionDetailsPageData();

	if (status === 'CLOSED') {
		return (
			<div className="block md:hidden">
				<div className="p-2 text-center">
					<Text as="h3" variant="heading" size="small">
						<span className="relative -bottom-0.5 mr-1 inline-block">
							<LockIcon />
						</span>
						<Translate value="fe.pages.petition_show.status.closed" />
					</Text>
				</div>
			</div>
		);
	}

	if (status === 'VICTORY') {
		return (
			<div className="block md:hidden">
				<div className="bg-gradient-background-dark-1 rounded-md p-2">
					<div className="text-typography-inverse-strong-fixed flex flex-row justify-center gap-1">
						<VictoryIcon className="mt-0.5 flex h-8! items-center" />
						<Text as="h3" variant="heading" size="small">
							{isVerifiedVictory ? (
								<Translate value="fe.pages.petition_show.status.confirmed_victory" />
							) : (
								<Translate value="fe.pages.petition_show.status.victory" />
							)}
						</Text>
					</div>
				</div>
			</div>
		);
	}

	return null;
};
